module.exports = __webpack_public_path__ + "img/tiktok_cn.5ec99d2f.png";